/* global globalThis */
export function apInputError(message) { const error=new Error(message);error.ap={status:400,code:'AP_INPUT_INVALID',message,conflict:false,uncertain:false,retryable:false,violations:[]};return error; }

/* AP writes are never retried with a new identity after an uncertain response. */
export function commandKey() {
    const crypto = globalThis.crypto;
    if (!crypto || !crypto.getRandomValues) {
        throw apInputError('Secure command identities are unavailable.');
    }
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function apiId(value) {
    const id = String(value == null ? '' : value);
    if (!/^(\d+|[a-f\d]{8}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{12})$/i.test(id)) {
        throw apInputError('Invalid AP resource identifier.');
    }
    return id;
}

export function allowed(capabilities, action) {
    return capabilities?.[action]?.allowed === true;
}

export function apError(error) {
    if(error.ap) return error.ap;
    const status = error.response?.status || null;
    const body = error.response?.data || {};
    return {
        status,
        code: body.code || (status ? `HTTP_${status}` : 'NETWORK_UNCERTAIN'),
        message: body.message || '',
        violations: body.violations || [],
        currentVersion: body.current_version ?? null,
        refreshUrl: body.refresh_url || null,
        conflict: status === 409 || status === 428,
        uncertain: !status || status >= 500,
        retryable: body.retryable === true || !status || status >= 500,
        retryAfter: error.response?.headers?.['retry-after'] || null,
    };
}

export function createCommandTransport(client, keyFactory = commandKey) {
    // Not persisted in localStorage: payloads can contain private financial data.
    const commands = new Map();
    return {
        inspect(identity) { return commands.get(identity) || null; },
        clear() { commands.clear(); },
        async execute({ identity, url, payload, method = 'post', dataFactory = null }) {
            if (!identity) throw apInputError('A logical command identity is required.');
            const fingerprint = JSON.stringify({ url, method, payload });
            let command = commands.get(identity);
            if (command && command.fingerprint !== fingerprint) {
                throw apInputError('The payload changed: confirm a new logical command.');
            }
            if (!command) {
                // Freeze what was confirmed, including the expected version.
                command = { dataFactory, key: keyFactory(), fingerprint, payload: JSON.parse(JSON.stringify(payload)), result: null, promise: null, error: null };
                commands.set(identity, command);
            }
            if (command.result) return command.result;
            if (command.promise) return command.promise;
            if (command.error && !command.error.retryable) {
                const error = new Error('This command requires a new user decision.');
                error.ap = command.error;
                throw error;
            }
            command.promise = client.request({ url, method, data: command.dataFactory ? command.dataFactory(command.payload) : command.payload, headers: { 'Idempotency-Key': command.key } })
                .then(response => {
                    command.result = response.data;
                    command.error = null;
                    return command.result;
                })
                .catch(error => {
                    command.error = apError(error);
                    error.ap = command.error;
                    throw error;
                })
                .finally(() => { command.promise = null; });
            return command.promise;
        },
    };
}
